var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading vh-100 vw-100 d-flex justify-content-center align-items-center position-fixed"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/spinner.gif"),"width":"130","alt":"loading"}})])
}]

export { render, staticRenderFns }